import axios from 'axios';
import { useCookies } from 'react-cookie'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from '../../common/util' 

function useDeleteClub() {
    const baseUrl = api.base_url;
    const [cookies, setCookie, removeCookie] = useCookies([ACCESS_TOKEN]);
    
    const deleteClub = async (academyId: number) => {
        try {
            const response = await axios(`${baseUrl}/academy/${academyId}`, {
                method: 'delete',
                headers: {
                  'Content-Type':'application/json',
                  'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`,
                },
            });

            return response.status;
            
        } catch (error) {
            console.error(error);
        }
    };

    return { deleteClub };
}

export default useDeleteClub;
